// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FooterInfo_wrapper__2Zx_s","copyright":"FooterInfo_copyright__RAGP7","links":"FooterInfo_links__2ADcP"};